<template>
  <div>
    <q-dialog v-model="thirteenthDialog">
      <div class="hris-modal hris-modal-lg">
        <div class="hris-modal-header" style="justify-content: center; flex-direction: column;">
          <q-img :src="companyLogoSrc" width="180px" height="90px" contain></q-img>
          <div style="text-align: center; margin-top: 8px;">
            <h2 class="hris-modal-title">Date: Jan {{ thirteenthMonthInfo.year }}</h2>
            <p class="hris-modal-subtitle">Jan {{ thirteenthMonthInfo.year }} - Dec {{ thirteenthMonthInfo.year }}</p>
          </div>
        </div>

        <div class="hris-modal-body">
          <q-markup-table dense flat bordered separator="cell">
            <tbody>
              <tr>
                <td class="text-right">Employee ID</td>
                <td class="text-left">{{ thirteenthMonthInfo.employee_id }}</td>
                <td class="text-right">Annual Salaries</td>
                <td class="text-left">{{ Number(thirteenthMonthInfo.annual_salaries).toLocaleString() }}</td>
              </tr>
              <tr>
                <td class="text-right">Employee Name</td>
                <td class="text-left">{{ thirteenthMonthInfo.employee_name }}</td>
                <td class="text-right">Net Gross</td>
                <td class="text-left">{{ Number(thirteenthMonthInfo.net_gross).toLocaleString() }}</td>
              </tr>
              <tr>
                <td class="text-right">Department</td>
                <td class="text-left">{{ thirteenthMonthInfo.dept_id }}</td>
                <td class="text-right">Thirteen Month</td>
                <td class="text-left">{{ Number(thirteenthMonthInfo.thirteen_month).toLocaleString() }}</td>
              </tr>
              <tr>
                <td class="text-right"></td>
                <td class="text-left"></td>
                <td class="text-right">Tardy</td>
                <td class="text-left">{{ Number(thirteenthMonthInfo.tardy).toLocaleString() }}</td>
              </tr>
              <tr>
                <td class="text-right"></td>
                <td class="text-left"></td>
                <td class="text-right">Deduction</td>
                <td class="text-left">{{ Number(thirteenthMonthInfo.deduction).toLocaleString() }}</td>
              </tr>
              <tr>
                <td class="text-right"></td>
                <td class="text-left"></td>
                <td class="text-right">Net Amount</td>
                <td class="text-left">{{ Number(thirteenthMonthInfo.net_amount).toLocaleString() }}</td>
              </tr>
            </tbody>
          </q-markup-table>
        </div>
      </div>
    </q-dialog>
    <q-dialog v-model="spinner" persistent>
      <div class="hris-loading">
        <q-spinner color="green" size="3em"></q-spinner>
      </div>
    </q-dialog>
  </div>
</template>
<script>
import axios from 'axios';
import defaultLogo from '../../assets/sgcc-black.png';
export default {
  data() {
    return {
      isCorrect: false,
      spinner: false,
      thirteenthDialog: false,
      thirteenthMonthInfo: {},
      companyLogoSrc: defaultLogo,
      companyLogoObjectUrl: null,
    }
  },

  created() {
    this.eventHub.$on('showthirteenthMonth', this.showthirteenthMonth);
    this.loadCompanyLogo();
  },

  computed: {
    companyLogoUrl() {
      return this.userData?.company_logo_url;
    }
  },

  watch: {
    companyLogoUrl: 'loadCompanyLogo',
    token: 'loadCompanyLogo'
  },

  methods: {

    showthirteenthMonth: function (payload) {
      this.thirteenthDialog = payload.stat
      this.thirteenthMonthInfo = payload.thirteenthMonth;
    },

    revokeCompanyLogoUrl() {
      if (this.companyLogoObjectUrl) {
        URL.revokeObjectURL(this.companyLogoObjectUrl);
        this.companyLogoObjectUrl = null;
      }
    },

    setDefaultLogo() {
      this.revokeCompanyLogoUrl();
      this.companyLogoSrc = defaultLogo;
    },

    async loadCompanyLogo() {
      const logoUrl = this.companyLogoUrl;
      if (!logoUrl || !this.token) {
        this.setDefaultLogo();
        return;
      }

      try {
        const response = await axios.get(logoUrl, {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        });
        this.revokeCompanyLogoUrl();
        this.companyLogoObjectUrl = URL.createObjectURL(response.data);
        this.companyLogoSrc = this.companyLogoObjectUrl;
      } catch (error) {
        this.setDefaultLogo();
      }
    }
  },

  beforeDestroy() {
    this.revokeCompanyLogoUrl();
  }
}
</script>
